<!-- Sidenav Container Start -->
<mat-sidenav-container class="sidenav-container">
  <!-- Sidenav Start -->
  <mat-sidenav mode="side" opened class="sidenav">
    <!-- Menu Header Start -->
    <div class="menu">
      <img src="/assets/images/logo-white.png" alt="sticky">
      Charge Clean <mat-icon>dehaze</mat-icon>
    </div>
    <!-- Menu Header End -->
    <!-- Navigation List Start -->
    <mat-nav-list class="drawer">
      <!-- Drawer Items Start -->
      <div class="drawer-items">
        @for (tab of tabs(); track tab.name) {
          <a mat-list-item [routerLink]="tab.route" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
            <div class="drawer-content">
              <mat-icon>{{tab.icon}}</mat-icon>{{tab.name}}
            </div>
          </a>
        }
      </div>
      <!-- Drawer Items End -->
      <!-- Logout Section Start -->
      <div class="logout" (click)="logout()">
        <mat-icon>logout</mat-icon> Logout
      </div>
      <!-- Logout Section End -->
    </mat-nav-list>
    <!-- Navigation List End -->
  </mat-sidenav>
  <!-- Sidenav End -->
</mat-sidenav-container>
<!-- Sidenav Container End -->
